import React, { useState } from "react";

const TabFilterCourse = ({
  setActiveCourse,
  activeCourse,
  categories,
  activeCategory,
}) => {
  // const [active, setActive] = useState(activeCategory);
  return (
    <>
      <div className="overflow-x-auto text-center mb-22">
        <div className="filtered-course-category mb-10">
          <div className="card-default-style px-20 py-14 d-inline-flex justify-content-center gap-2 gap-md-3">
            {categories.map((category) => (
              <button
                style={{ whiteSpace: "nowrap" }}
                key={category}
                className={`btn ah-text-sm py-8 px-15 ${
                  activeCourse === category
                    ? "btn-primary"
                    : "btn-primary-revert no-shadow"
                }`}
                onClick={() => setActiveCourse(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabFilterCourse;
